<template>
  <div class="apply-form__section apply-form__privacy-policy">
    <h2>{{ $t('application.summary') }}</h2>
    <p>{{ $t('application.summaryInfo') }}</p>

    <div class="d-block d-md-flex align-center">
      <v-btn
        v-if="false"
        :block="blockButton"
        class="secondary d-md-inline mt-4 mt-md-0"
      >
        {{ $t('application.downloadApplication') }}
      </v-btn>

      <v-btn
        @click="$emit('submit')"
        :block="blockButton"
        :loading="submitting"
        :disabled="applicationDisabledMode || disabled"
        color="primary"
        class="ml-md-4 mt-4 mt-md-0 d-md-inline"
      >
        {{ $t('application.sendApplication') }}
        <v-icon class="ml-4">mdi-send</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    submitting: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    blockButton() {
      return (
        this.$vuetify.breakpoint.name === 'xs' ||
        this.$vuetify.breakpoint.name === 'sm'
      );
    },

    applicationDisabledMode() {
      return process.env.VUE_APP_DISABLE_APPLY === 'true';
    }
  }
};
</script>
